export default "__VITE_ASSET__6906d8eb__"